// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import Difficulty from "./difficulty_type";


export default __t.row({
  id: __t.u64().primaryKey(),
  userId: __t.u64().name("user_id"),
  username: __t.string(),
  get difficulty() {
    return Difficulty;
  },
  boardWidth: __t.u8().name("board_width"),
  boardHeight: __t.u8().name("board_height"),
  minesCount: __t.u16().name("mines_count"),
  completionTimeMs: __t.u32().name("completion_time_ms"),
  isWin: __t.bool().name("is_win"),
  mineLayout: __t.string().name("mine_layout"),
  movesData: __t.string().name("moves_data"),
  createdAt: __t.u64().name("created_at"),
});
